import React from "react";

import cx from "classnames";
import { get } from "lodash";

import favoriteSongStore from "../../../zustand/favoriteSong.store";
import { songActions } from "../../../actions";
import Icons from "../../icons";
import { ICONS } from "../../../constants/icons.constants";

import styles from "./favourite.module.scss";
import userStore from "../../../zustand/user.store";
import ignoredSongStore from "../../../zustand/ignoreSong.store";

const Favourite = ({ row, likepage }) => {
  const { songs: favoriteSongs, setFavouriteToSong } = favoriteSongStore();
  const { removeIgnoreFromSong } = ignoredSongStore();
  const { userOffline } = userStore((state) => ({
    userOffline: state.userOffline,
  }));

  const id = get(row, "id", "");

  const handleFavoriteIconClick = async (e) => {
    e.stopPropagation();
    setFavouriteToSong(id);
    removeIgnoreFromSong(id);

    const isSuccess = await songActions.addFavouriteToSong(id, userOffline);

    if (!isSuccess) {
      setFavouriteToSong(id);
      removeIgnoreFromSong(id);
      return;
    }
  };

  return (
    <div
      className={cx(styles.column3, {
        [styles.favorite]: get(favoriteSongs, id, false),
      })}
      onClick={handleFavoriteIconClick}
    >
      <Icons type={ICONS.LIKE_SONG_LIST} />
    </div>
  );
};

export default Favourite;
